import React from "react";
import { Box, Button } from "@mui/material";

export const ButtonYellow = ({ onClick, children, sx = {}, buttonProps, ...props }) => {
    return (
        <Box
            sx={{
                background: 'linear-gradient(0deg, #CCCCCC -2.68%, #E6E6E6 31.68%, #F8F8F8 64.23%, #FFFFFF 87.74%)',
                borderRadius: '50px',
                padding: '5px 5px',
                // left: '50%',
                // transform: 'translateX(-50%)',
                // position: 'absolute',
                // bottom: '-20px',
                width: { sm: 'auto' }, // Adjust width to ensure it fits smaller screens
                ...sx
            }}
            {...props}
        >
            <Button
                sx={{
                    background: 'linear-gradient(to top, #ff6300, #ff7c00, #ff9400, #ffaa00, #ffbf00, #ffc80b, #ffd116, #ffda20, #ffd91a, #ffd814, #ffd60b, #ffd500)',
                    color: '#fff',
                    borderRadius: '50px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: { xs: '5px 10px', sm: '10px 20px' },
                    width: '100%',
                    position: 'relative',
                    overflow: 'hidden',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)', // Adds subtle depth to the button
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '100%',
                        height: '50%', // Covers the top half of the button
                        background: 'rgba(255, 255, 255, 0.3)', // Semi-transparent white for shine
                        borderRadius: 'inherit', // Match button's border-radius
                        transform: 'translateY(-60%)', // Position the shine near the top
                        filter: 'blur(10px)', // Smoothens the shine effect
                        pointerEvents: 'none', // Ensures the overlay doesn't interfere with button interactions
                    },
                    '&:hover': {
                        background: 'linear-gradient(to top, #ff6300, #ff7c00, #ff9400, #ffaa00, #ffbf00)', // Slightly adjust the gradient on hover
                        boxShadow: '0 6px 10px rgba(0, 0, 0, 0.3)', // Enhance the shadow on hover for a pop-out effect
                    },
                    '&:disabled': {
                        cursor: 'not-allowed',
                        background: `rgba(229, 226, 226, 1);`
                    },
                }}
                onClick={onClick}
                {...buttonProps}
            >
                {children}
            </Button>
        </Box>
    )
}